<template>
<div class="instructor-profile section-holder">
    <div class="container text-center">
        <h6>{{$t('instructor_profile.course_taught_by')}} </h6>
        <div class="user-details">
            <div class="user-pic"><img class="img-responsive" src="/static/assets/images/user.png" alt=""></div>
            <div class="user-info">
                <div class="user-name">{{$t('instructor_profile.instructor_name')}}</div>
                <div class="user-title">{{$t('instructor_profile.designation')}}</div>
                <div class="rating-star">
                    <i class="mdi mdi-star" aria-hidden="true"></i>
                    <i class="mdi mdi-star" aria-hidden="true"></i>
                    <i class="mdi mdi-star" aria-hidden="true"></i>
                    <i class="mdi mdi-star" aria-hidden="true"></i>
                    <i class="mdi mdi-star-half" aria-hidden="true"></i>
                    <span> (234 votes)</span>
                </div>
                <div class="user-title"><a href="#"> {{$t('instructor_profile.view_profile')}} </a></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'instructorProfile',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.instructor-profile{
    color: #333333;
    h6{ 
        font-size: 14px; margin-bottom: 20px; 
        /*font-weight: 600;*/
        line-height: 24px;
        color: #656565;
    }
     .user-pic {
        margin-right: 10px;
        width: 100px;
        height: 100px;
        display: inline-block;
        vertical-align: middle;
        border: 0px solid #fff;
        border-radius: 50%;
        overflow: hidden;
    }
    .rating-star{ font-size:12px;}
    .user-info{ 
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        .user-name {
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
        }
        .user-title{
        font-size: 12px; text-transform: capitalize;
        line-height: 22px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/profile/instructorProfile.vue?29e272bc